import { useMutation, useQueryClient } from '@tanstack/vue-query';
import { finishWorkoutFromCheckpoint } from '../workout.api';
import { useAppToasts } from '@/hooks/use-app-toasts';
import { QueryKey } from '@/api/common/types/query-key.enum';
import type { Workout } from '../types/workout';
import type { FinishWorkoutResponse } from '../types/finish-workout-response';

export const useFinishWorkoutFromCheckpoint = () => {
  const queryClient = useQueryClient();
  const { raiseErrorToast } = useAppToasts();
  const { mutateAsync, isPending } = useMutation({
    mutationKey: [QueryKey.FinishWorkout, 'from-checkpoint'],
    mutationFn: (workoutEventId: string) => finishWorkoutFromCheckpoint(workoutEventId),
    onSuccess: async (res: FinishWorkoutResponse, workoutEventId) => {
      queryClient.setQueryData([QueryKey.FinishWorkoutAward, workoutEventId], res);
      queryClient.setQueryData<Workout>([QueryKey.GetWorkout, workoutEventId], old =>
        old
          ? {
              ...old,
              duration: res.duration,
              calBurn: res.calBurn,
            }
          : old
      );
      await queryClient.invalidateQueries({ queryKey: [QueryKey.GetWorkouts] });
      await queryClient.invalidateQueries({ queryKey: [QueryKey.GetLoggedInUser] });
      await queryClient.invalidateQueries({ queryKey: [QueryKey.GetRecoverableWorkout] });
      await queryClient.invalidateQueries({ queryKey: [QueryKey.GetGroups] });
      await queryClient.invalidateQueries({ queryKey: [QueryKey.GetLeaderboard] });
    },
    onError: () => {
      raiseErrorToast();
    },
  });
  return {
    finishWorkoutFromCheckpoint: mutateAsync,
    loading: isPending,
  };
};
